import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { shareIcons } from '../../shared/styles/icons';
import Viewports from '../../../assets/components/fsUtils/Viewports';
import {generateShareLinks} from '../../shared/services/SharingService';
import withCopyToClipboard from '../../shared/components/withCopyToClipboard';
import withTracking from '../../shared/components/withTracking';

const sharedClassName = ' share-btn';
const CopyLink = withCopyToClipboard((props) => (
        <button {...props}><span className={css(shareIcons.icUrlShare) + sharedClassName}> </span></button>),
    'data-social-tooltip'
);

class VideoShare extends React.Component {
    constructor(props){
        super(props);

        this.viewport = new Viewports();

        this.isMobile = this.viewport.isTouch || this.viewport.winW < 1024;
        this.isAndroid = this.viewport.isAndroid;

    }

    render() {
        const shareStyles = [shareIcons.icMarginLeft, shareIcons.icShareDefault];

        this.shareLinks = generateShareLinks(this.props.title, this.props.videoUrl, this.props.utmTerm);

        return (
            <div className={css(shareIcons.inlineContainer)}>
                <a href={this.shareLinks.fb} data-share-type={"fb"}
                   target="_blank" className={css(shareIcons.icShareDefault) + " share-btn"} onClick={this.props.trackShareLink}> <span className={css(shareIcons.icFacebook) + sharedClassName}></span> </a>
                { this.isMobile && <a href={this.shareLinks.whatsapp} data-share-type={"whatsapp"} className={css(shareStyles)} onClick={this.props.trackShareLink}> <span className={css(shareIcons.icWhatsappShare) + sharedClassName}></span> </a> }
                { this.isMobile && <a href={this.shareLinks.sms} data-share-type={"sms"} className={css(shareStyles)} onClick={this.props.trackShareLink}> <span className={css(shareIcons.icSmsShare) + sharedClassName }></span> </a> }
                {/* <a href={this.shareLinks.tw} target="_blank" className={css(shareIcons.icShare)}>
                     <span className={css([shareIcons.icTwitterShare, shareIcons.icShare ])}></span> </a> */}
                { !this.isMobile && <CopyLink data-share-type={"url"} data-copy-text={this.shareLinks.cpyLink} copyCallback={this.props.trackShareLink} className={css(shareStyles, shareIcons.icShareBtn) + " social-bar-button share-url"} /> }
                { !this.isMobile && <a href={this.shareLinks.em} data-share-type={"email"} className={css(shareStyles)}> <span className={css(shareIcons.icEmailShare) + sharedClassName} ></span> </a> }

            </div>
        );
    }

}

export default withTracking(VideoShare);
